var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FooterService } from "../../services/footer.service";
import { UserService } from "../../services/user.service";
import { EduComponent } from "../../utils/eduComponent";
import Utils from "../../utils/utils";
import { InformationModalComponent } from "../modals/information-modal/information-modal.component";
var FooterComponent = /** @class */ (function (_super) {
    __extends(FooterComponent, _super);
    function FooterComponent(footerService, modalService, userService) {
        var _this = _super.call(this) || this;
        _this.footerService = footerService;
        _this.modalService = modalService;
        _this.userService = userService;
        _this.feedbackFormHtml = null;
        _this.gtmPrefix = "gtm-footer-";
        _this.pbsLogoWhite = require("../../../assets/PBS-logo-white.svg");
        return _this;
    }
    FooterComponent.prototype.ngOnInit = function () {
        this.isStudent = this.userService.hasStudentExperience();
        this.currentYear = Utils.getCurrentYear();
    };
    FooterComponent.prototype.buildFeedbackForm = function (event) {
        var _this = this;
        event.preventDefault();
        this.addSub(this.footerService.getFeedbackFormHtml().subscribe(function (response) {
            _this.feedbackFormHtml = response;
        }));
    };
    FooterComponent.prototype.subscribe = function () {
        var _this = this;
        var settings = window.PBSLM.eloqua.footer;
        var subscribeBtn = document.getElementById("eloqua-newsletter-go");
        if (subscribeBtn.getAttribute("disabled") === "true") {
            return;
        }
        var email = document.getElementById("email-eloqua-newsletter").value;
        subscribeBtn.classList.add("disabled");
        subscribeBtn.setAttribute("disabled", "true");
        this.addSub(this.footerService
            .subscribeToNewsletter(settings.url, settings.elqFormName, settings.elqSiteId, email)
            .subscribe(function (response) {
            subscribeBtn.classList.remove("disabled");
            subscribeBtn.removeAttribute("disabled");
            var informationModal = _this.modalService.open(InformationModalComponent);
            informationModal.componentInstance.message =
                "You have been subscribed to the newsletter!";
        }, function (error) {
            subscribeBtn.classList.remove("disabled");
            subscribeBtn.removeAttribute("disabled");
            var informationModal = _this.modalService.open(InformationModalComponent);
            informationModal.componentInstance.message =
                "Something went wrong. Please try again later.";
        }));
    };
    FooterComponent.prototype.submitForm = function () {
        var _this = this;
        var csrfmiddlewaretoken = document.querySelector("#feedback_form input[name='csrfmiddlewaretoken']").value;
        var name = document.getElementById("id_name")
            .value;
        var email = document.getElementById("id_email")
            .value;
        var comment = document.getElementById("id_comment").value;
        var captchaResponse = document.getElementById("g-recaptcha-response").value;
        this.addSub(this.footerService
            .submitFeedback(csrfmiddlewaretoken, name, email, comment, captchaResponse)
            .subscribe(function (response) {
            _this.feedbackFormHtml = response;
        }));
    };
    return FooterComponent;
}(EduComponent));
export { FooterComponent };
